import { IpUserMiddlewaresService } from './ip-middlewares.service';

// No limitations are applied for Paid users
export default class PaidUsersMiddleware extends IpUserMiddlewaresService { }
